<template>
  <div
    v-loading="tableLoading"
    class="todo"
  >
    <sw-table
      ref="todoTable"
      :page-sizes="[10,15,20]"
      :page-size="pageSize"
      :total-count="tableCount"
      :show-selection="false"
      :table-name="'sw-todo-table'"
      :table-title="tableTitle"
      :table-data="tableData"
      :table-operation="tableOperation"
      :has-add-button="false"
      style="background: #fff"
      @row-click="rowClick"
      @operation-handle="handleOperation"
      @size-change="changeSize"
      @change-page="changePage"
      @next-page="changePage"
      @prev-page="changePage"
    >
      <template
        slot="customcolumn"
        slot-scope="scope"
      >
        <span v-if="scope.item.prop=='swResource'">
          {{ scope.row.swResource }}

          <el-tooltip
            v-if="scope.row.isUrgent === '1'"
            content="催办事务"
            placement="top"
            style="margin-left:3px"
          >
            <i
              class="su-icon-cuiban"
              style="color: #E6A23C;"
            />
          </el-tooltip>
          <el-tooltip
            v-if="scope.row.isUrgent === 'true'"
            content="转办事务"
            placement="top"
            style="margin-left:3px"
          >
            <i
              class="su-icon-zhuanyue"
              style="color: #E6A23C;"
            />
          </el-tooltip>
        </span>
        <span
          v-else
          :title="scope.row[scope.item.prop]?scope.row[scope.item.prop]:'-'"
          class="swTableCell"
        >
          {{ scope.row[scope.item.prop]?scope.row[scope.item.prop]:'-' }}
        </span>
      </template>
    </sw-table>
  </div>
</template>
<script>
import service, { designFormUrl } from '@/utils/service.js'
import { parseTime } from '@/utils/index.js'
import '../css/worklist/todo.scss'
export default {
  data () {
    return {
      tableLoading: false,
      expandColumns: [],
      pageSize: 10,
      currentPage: 1,
      tableCount: 0,
      tableData: [],
      expands: [],
      tableTitle: [
        { prop: 'serialNumber', label: '流水号', width: '120', sortable: true },
        { prop: 'swResource', label: '事务来源', width: '120', sortable: true },
        { prop: 'swName', label: '事务名称', width: '120', sortable: true },
        { prop: 'userName', label: '发起人', width: '120', sortable: true },
        { prop: 'organization', label: '发起人单位', width: '120', sortable: true },
        { prop: 'applyTime', label: '发起时间', width: '120', sortable: true },
        { prop: 'createTime', label: '到达时间', width: '120', sortable: true },
        { prop: 'spendTime', label: '已耗时', width: '120', sortable: true }
      ],
      tableOperation: [
        { name: '办理', icon: 'su-icon-edit', operation: 'edit' }
      ]
    }
  },
  computed: {
    pageVisible () {
      return this.$store.state.appflow.pageVisible
    }
  },
  watch: {
    pageVisible (val) {
      if (val) {
        this.getData()
      }
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      this.tableLoading = true
      this.expandColumns = []
      service.get('/v1/process/showToDoTaskList', {
        params: {
          page: this.currentPage,
          limit: this.pageSize
        }
      }).then(res => {
        this.tableLoading = false
        this.tableData = res.data.map((item, index) => {
          item.id = index + '&' + item.id
          // item.spendTime = item.spendTime
          item.createTime = parseTime(item.createTime)
          item.applyTime = parseTime(item.applyTime)
          if (item.detail) {
            item.detail.reverse()
            item.detail = item.detail.map(d => {
              let status = '未审核'
              if (d.deleteReason) {
                switch (d.deleteReason) {
                  case 'completed':
                    status = '已审核'
                    break
                  case 'reject':
                    status = '被驳回'
                    break
                  case 'delegate':
                    status = '已代理'
                    break
                  default:
                    status = '未通过'
                }
              }
              return { name: d.name, assignee: d.assigneeName, endTime: parseTime(d.endTime), comment: d.comment, status: status }
            })
          }
          return item
        })
        this.tableCount = res.count
      }).catch(error => {
        this.$swMessage.error(error)
      })
    },
    getRowKeys (row) {
      return row.id
    },
    handleWarningRow (approval) {
      if (approval.status === 'reject') {
        return true
      } else {
        return false
      }
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
    },
    changeSize (size) {
      this.pageSize = size
      this.currentPage = 1
      this.getData()
    },
    changePage (page) {
      this.currentPage = page
      this.getData()
    },
    rowClick (row) {

    },
    handleOperation (id, operation) {
      if (operation === 'edit') {
        this.handleForm(id)
      } else {
        this.handleToggleExpand(id)
      }
    },
    handleToggleExpand (id) {
      const tempRow = this.tableData.find(item => {
        return item.id === id
      })
      if (this.expandColumns.includes(tempRow.id)) {
        this.expandColumns.splice(this.expandColumns.indexOf(tempRow.id), 1)
        this.$refs.todoTable.tableMethod('toggleRowExpansion', tempRow, false)
      } else {
        this.expandColumns.push(tempRow.id)
        this.$refs.todoTable.tableMethod('toggleRowExpansion', tempRow, true)
      }
    },
    handleForm (id) {
      const tempRow = this.tableData.find(item => {
        return item.id === id
      })
      const idIndex = id.indexOf('&')
      id = id.slice(idIndex + 1, id.length)
      window.open(`${designFormUrl}/handle?fid=${tempRow.fid}&from=adminplatform&ffid=${tempRow.ffid}&taskid=${id}&processInstanceId=${tempRow.processInstanceId}&token=${localStorage.getItem('Admin-Token')}`, '_blank')
    }
  }
}
</script>
